import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
  production: true,
  s3HowtoUrl: 'https://df-fa-howto.s3.eu-central-1.amazonaws.com/',
  apiUrl: 'https://api.sup-controlling.siemens.cloud/api/',
  newApiUrl: 'https://api.sup-controlling.siemens.cloud/api/v2.0a/',
  systemUrl: 'https://sup-controlling.siemens.cloud/',
  plannedAbsencesProjectPlaceholder: 'Geplante Abwesenheiten',
  cognitoId: 'eu-central-1:feacc8c9-0371-453f-ae68-135d618c4dbd',
  reporting: 'https://siemens.pulse.cloud/project/176',
  serviceDeskLink: 'https://jira.siemens.cloud/gms/servicedesk/customer/portal/1358',
  scdApiKey: 'FHUkvSpVXs74gwjpQtLqLa1d6BnN7B2O4HnrHV0N',
  sentryEnabled: false,
  sentryDsn: 'https://7233f7d0d8159cb3f25f01869075073d@crash.siemens.com/363',
  mailingService: {
    endPoint: 'https://api.clients.juno.suites.siemens.cloud/v3/mail-jobs',
    appId: 'd12061b8275e4b0590620c8af490564d',
  },
  profilePath: 'https://api.sup-controlling.siemens.cloud/api/userprofile',
  S3buckets: {
    howTo: 'df-fa-howto',
  },
  s3Region1: 'eu-central-1',
  msalConfig: {
    auth: {
      clientId: '647640b8-8d3d-439d-86c9-283e77c3a778',
      authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a', // Your tenant ID in format https://login.microsoftonline.com/${tenantId}
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      allowPlatformBroker: false,
    },
  },
  apiConfig: [
    {
      scopes: ['https://api.sup-controlling.siemens.cloud/api/App.Access', 'offline_access'],
      uri: 'https://api.sup-controlling.siemens.cloud/api/',
    },
    {
      scopes: ['https://api.scd.suites.siemens.cloud/SCD.Read'],
      uri: 'https://api.scd.suites.siemens.cloud/v2/persons',
    },
    {
      scopes: ['https://api.clients.juno.suites.siemens.cloud/MailJob.ReadWrite'],
      uri: 'https://api.clients.juno.suites.siemens.cloud/v3/mail-jobs',
    },
    {
      scopes: ['User.ReadBasic.All', 'User.Read'],
      uri: 'https://graph.microsoft.com/v1.0',
    },
  ],
};
